module.exports = __webpack_public_path__ + "static/media/sakshi_mehtre.dc165a5d.png";